module.exports = __webpack_public_path__ + "static/media/greyCircleIcon.50d57b83.svg";